import { useMemo } from "react"

export const useGetRemovedHistoryItem = (diffItem) => {
  return useMemo(() => {
    if (!diffItem) return { removed: false };
    if (diffItem?.length === 3 && diffItem?.[2] === 0) return { removed: true, value: diffItem?.[0] };
    if (diffItem?.length === 2) return { removed: !diffItem?.[1], value: diffItem?.[0] };
    return { removed: false };
  }, [diffItem])
}